// SEO из шаблонов API (seoTemplate) — запасной вариант, когда seoTag для страницы пустой.
// Шаблоны в формате Mustache, но нужна только малая часть: {{a.b}}, {{#a.b}}…{{/a.b}}, {{^a.b}}…{{/a.b}}
// и лямбды numberFormat / engineVolume / lower — поэтому без библиотеки.

const toNumber = (text) => {
  const value = Number(String(text).replace(/\s/g, '').replace(',', '.'))
  return text === '' || Number.isNaN(value) ? undefined : value
}

const lambdas = {
  numberFormat: (text) => {
    const value = toNumber(text)
    return value === undefined ? '' : new Intl.NumberFormat('ru-RU').format(value)
  },
  engineVolume: (text) => {
    const value = toNumber(text)
    return value === undefined ? '' : value.toFixed(1)
  },
  lower: (text) => text.toLocaleLowerCase('ru-RU'),
}

const getValue = (view, path) => path.split('.').reduce((obj, key) => (obj == null ? undefined : obj[key]), view)

const isTruthy = (value) => !(value == null || value === false || value === '' || (Array.isArray(value) && !value.length))

const renderVars = (text, view) => text.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (_, path) => {
  const value = getValue(view, path)
  return value == null ? '' : String(value)
})

// Секция без вложенных секций внутри — разворачиваем изнутри наружу
const innermostSection = /\{\{([#^])\s*([\w.]+)\s*\}\}((?:(?!\{\{[#^])[\s\S])*?)\{\{\/\s*\2\s*\}\}/

export function renderSeoString(template, view) {
  if (!template) return ''
  let text = String(template)
  let match
  while ((match = text.match(innermostSection))) {
    const [whole, type, name, inner] = match
    let result
    if (type === '#' && lambdas[name]) {
      result = lambdas[name](renderVars(inner, view))
    } else {
      const truthy = isTruthy(getValue(view, name))
      result = (type === '#' ? truthy : !truthy) ? inner : ''
    }
    text = text.replace(whole, result)
  }
  return renderVars(text, view).replace(/\s{2,}/g, ' ').trim()
}

export function renderSeoTemplate(template, view) {
  return {
    title: renderSeoString(template.title, view),
    page_title: renderSeoString(template.h1, view),
    description: renderSeoString(template.description, view),
    crumbs: (template.crumbs || []).map((crumb) => ({
      title: renderSeoString(crumb.title, view),
      link: renderSeoString(crumb.link, view),
    })),
  }
}

// Имя шаблона по маршруту страницы (страницы этого проекта называются не так, как шаблоны в API)
const PAGE_TEMPLATES = {
  contact: 'contacts',
  podbor: 'select',
  rassrochka: 'installments',
}

export function seoTemplateName(route) {
  switch (route.name) {
    case 'index':
      return 'index'
    case 'category':
      return 'category'
    case 'category-mark':
      return 'category-mark'
    case 'category-mark-model':
      return 'category-mark-folder'
    case 'category-mark-model-car':
      // /cars/:mark/:model/:car — :car это либо id машины, либо поколение
      return Number(route.params.car) ? 'category-mark-folder-offer' : 'category-mark-folder-generation'
    default: {
      const [first, second] = route.path.toLowerCase().split('/').filter(Boolean)
      if (first === 'credit' && second) return 'credit-bank'
      return PAGE_TEMPLATES[first] || first || 'index'
    }
  }
}
